<template>
  <section
    class="c-section c-section-hero-multiple"
    :class="{ 'c-section-hero-multiple--4-tiles': otherProducts.length === 4 }"
  >
    <div
      v-for="product in otherProducts"
      :key="product.id"
      class="c-section-hero-multiple__banner"
    >
      <ui-tile
        :product="product"
        :layout="TileLayout.HERO_MULTIPLE"
        show-play-product
      ></ui-tile>
    </div>
  </section>
</template>
<script>
  import sampleSize from 'lodash/sampleSize';
  import { meta, truncate } from '@/index/shared/filters';
  import { TileLayout, TrailerMode } from '@/shared/enums';
  import UiTile from '../../tile/index.vue';

  export default {
    name: 'HeroMultiple',
    components: {
      UiTile,
    },
    enums: {
      TileLayout,
      TrailerMode,
    },
    filters: {
      meta,
      truncate,
    },
    inject: ['$section'],
    computed: {
      otherProducts() {
        const pinnedProducts = this.$section.products.filter((product) => product.pinned);
        const notPinnedProducts = this.$section.products.filter((product) => !product.pinned);
        return [...pinnedProducts, ...sampleSize(notPinnedProducts, 6)].slice(0, 6);
      },
    },
  };
</script>
